import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    userInfo: {},
    lang: {
      zh: {
        today: '今日',
        yes: '昨日',
        month: '月度',
        join: "参与",
        income: "收益",
        date: "日期"
      },
      en: {
        today: 'Today',
        yes: 'Weekly',// 昨天 -->改周
        month: 'Monthly',
        join: "Bet",
        income: "Income",
        date: "Date"
      },
      ar: {
        today: "اليوم",
        yes: "أسبوعيا", //昨天 昨天 -->改周
        month: "شهريا",
        join: "الرهان",
        income: "الايرادات",
        date: "تاريخ"
      },
      tr: {
        today: 'Bugün',
        yes: 'Haftalık',// 昨天 -->改周
        month: 'Aylık',
        join: "birleştirmek",
        income: "gelir",
        date: "tarih"
      },
    }
  }

  @action async GetUserInfoWeb(uid) {
    let resParams = await http.post('/web/MyAccountInfo', { uid: uid })
    this.data.userInfo = resParams.res
    return resParams
  }

  /**
   * @description ludo天排行  0今天 1昨天
   * @returns
   */
  @action async apiGetLudoRank(v,type=1) {
    let data = await http.post('/web/ludo/day/rank', { rType: v,type })
    return data
  }

  /**
   * @description ludo月排行 0本月 1上月
   * @returns
   */
  @action async apiGetLudoMonthRank(v,type=1) {
    let data = await http.post('/web/ludo/month/rank', { rType: v,type })
    return data
  }

  /**
   * @description ludo记录
   * @returns
   */
  @action async apiGetLudoRecord(v,type=1) {
    let data = await http.post('/web/ludo/record', { scroll: v,type})
    return data
  }

  @action async apiGetLudoWeekRank(v) {
    let data = await http.post('/web/ludo/week/rank', { rType: v })
    return data
  }
}





// WEBPACK FOOTER //
// src/store/ludo/main.js